"use strict";

var __importDefault = this && this.__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};
Object.defineProperty(exports, "__esModule", {
  value: true
});
var request_1 = __importDefault(require("request"));
var RequestHelper = /** @class */function () {
  function RequestHelper() {}
  RequestHelper.configurarMicroservicios = function (microservicios) {
    RequestHelper.microservicios = microservicios;
  };
  RequestHelper.configurarLogger = function (logger) {
    RequestHelper.logger = logger;
  };
  RequestHelper.post = function (url, options) {
    if (RequestHelper.logger != null) {
      if (options != null && options.headers != null && options.headers.key != null) {
        RequestHelper.logger(options.headers.key, url, options.json, options.headers);
      } else {
        RequestHelper.logger(null, url, options.json, options.headers);
      }
    }
    return new Promise(function (resolve, reject) {
      request_1.default.post(url, options, function (error, body) {
        if (error) reject(error);else resolve(body);
      });
    });
  };
  RequestHelper.get = function (url, options) {
    if (RequestHelper.logger != null) {
      if (options != null && options.headers != null && options.headers.key != null) {
        RequestHelper.logger(options.headers.key, url, options, options);
      } else {
        RequestHelper.logger(null, url, options, options);
      }
    }
    return new Promise(function (resolve, reject) {
      request_1.default.get(url, options, function (error, body) {
        if (error) reject(error);else resolve(body);
      });
    });
  };
  RequestHelper.consultaMicroservicio = function (codigoMs, data, key, token) {
    if (token === void 0) {
      token = null;
    }
    if (!RequestHelper.microservicios) throw new Error("Primero debe configurar el listado de microservicios");
    var ms = RequestHelper.microservicios.find(function (x) {
      return x.codigo === codigoMs;
    });
    if (!ms) throw new Error('No fue posible encontrar el microservicio ' + codigoMs);
    if (RequestHelper.microservicios) {
      return RequestHelper.post(ms.host, {
        json: data,
        headers: {
          key: key,
          token: token
        }
      });
    }
  };
  RequestHelper.request = function (options) {
    return new Promise(function (resolve, reject) {
      request_1.default(options, function (err, res, body) {
        if (err) reject(err);else resolve({
          response: res,
          body: body
        });
      });
    });
  };
  return RequestHelper;
}();
exports.default = RequestHelper;